const Cultures = {
  uk: {
    id: "da84d36d-48d7-4796-9ff0-56aadf652d81",
    name: "Українська",
    code: "uk"
  },
  en: {
    id: "5a5b47c5-4a2c-488b-8ac0-cc13218e7632",
    name: "English",
    code: "en"
  }
};
const CulturesArray = Object.values(Cultures);
export {
  Cultures,
  CulturesArray
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ3VsdHVyZXMuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1B1YmxpY0FydGljbGVzL0N1bHR1cmVzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBDdWx0dXJlcyA9IHtcblx0dWs6IHtcblx0XHRpZDogXCJkYTg0ZDM2ZC00OGQ3LTQ3OTYtOWZmMC01NmFhZGY2NTJkODFcIixcblx0XHRuYW1lOiBcItCj0LrRgNCw0ZfQvdGB0YzQutCwXCIsXG5cdFx0Y29kZTogXCJ1a1wiLFxuXHR9LFxuXHRlbjoge1xuXHRcdGlkOiBcIjVhNWI0N2M1LTRhMmMtNDg4Yi04YWMwLWNjMTMyMThlNzYzMlwiLFxuXHRcdG5hbWU6IFwiRW5nbGlzaFwiLFxuXHRcdGNvZGU6IFwiZW5cIixcblx0fVxufTtcblxuZXhwb3J0IGNvbnN0IEN1bHR1cmVzQXJyYXkgPSBPYmplY3QudmFsdWVzKEN1bHR1cmVzKTtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBTyxNQUFNLFdBQVc7QUFBQSxFQUN2QixJQUFJO0FBQUEsSUFDSCxJQUFJO0FBQUEsSUFDSixNQUFNO0FBQUEsSUFDTixNQUFNO0FBQUEsRUFDUDtBQUFBLEVBQ0EsSUFBSTtBQUFBLElBQ0gsSUFBSTtBQUFBLElBQ0osTUFBTTtBQUFBLElBQ04sTUFBTTtBQUFBLEVBQUE7QUFFUjtBQUVhLE1BQUEsZ0JBQWdCLE9BQU8sT0FBTyxRQUFROyJ9
